import { z } from "zod";
import { CURRENCIES } from "@/lib/constants";

export const budgetItemSchema = z.object({
  category_id: z.string().uuid("Category is required"),
  sub_category_id: z.string().uuid("Sub-category is required"),
  amount: z.number().positive("Amount must be greater than zero"),
  currency: z.enum(CURRENCIES as [string, ...string[]], {
    required_error: "Currency is required",
  }),
  description: z.string().optional(),
});

export type BudgetItemInput = z.infer<typeof budgetItemSchema>;
